export const PROJECT = '[Project]';

export const GET_PROJECTS_SAGA = `${PROJECT} GET_PROJECTS_SAGA`;
export const SET_PROJECTS = `${PROJECT} SET_PROJECTS`;
